(function () {
  // Respects your original Fast Sync CSS logic by using empty innerHTML to hide
  function showStatus(root, type, message) {
    var status = root.querySelector('[data-favorites-status]');
    if (status) {
      status.dataset.status = type;
      if (type === 'loading') {
        status.innerHTML = `<span class="favorites-loading-text">${message}</span>`;
      } else {
        status.innerHTML = message;
      }
    }
  }

  function hideStatus(root) {
    var status = root.querySelector('[data-favorites-status]');
    if (status) {
      status.innerHTML = ''; // Your CSS :empty rule will hide it
      delete status.dataset.status;
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[char];
    });
  }

  function getFavoritesArray(payload) {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.favorites)) return payload.favorites;
    if (payload.data && Array.isArray(payload.data.favorites)) return payload.data.favorites;
    if (payload.data && Array.isArray(payload.data)) return payload.data;
    return [];
  }

  function getField(item, keys) {
    for (var i = 0; i < keys.length; i += 1) {
      if (item && item[keys[i]] !== undefined && item[keys[i]] !== null && item[keys[i]] !== '') {
        return item[keys[i]];
      }
    }
    return '';
  }

  function normalizeShopifyId(id) {
    var match = String(id || '').match(/(\d+)(?:\D*)$/);
    return match ? match[1] : '';
  }

  function getProductImage(product) {
    var image = getField(product, ['image', 'featured_image', 'featuredImage']);

    if (image && typeof image === 'object') {
      return image.src || image.url || '';
    }

    if (image) return image;

    if (product && Array.isArray(product.images) && product.images.length) {
      var firstImage = product.images[0];
      return typeof firstImage === 'string' ? firstImage : firstImage.src || firstImage.url || '';
    }

    return '';
  }

  function getProductTags(product) {
    var tags = product && product.tags;

    if (Array.isArray(tags)) return tags;
    if (typeof tags === 'string') {
      return tags.split(',').map(function (tag) {
        return tag.trim();
      }).filter(Boolean);
    }

    return [];
  }

  function getFavoriteProductId(source, product) {
    var productId = getField(source, ['product_id', 'productId', 'shopify_product_id', 'shopifyProductId']);

    if (!productId && product.id) {
      productId = product.id;
    }

    if (!productId && source.id && (/^\d+$/.test(String(source.id)) || String(source.id).indexOf('gid://shopify/Product/') === 0)) {
      productId = source.id;
    }

    return normalizeShopifyId(productId);
  }

  function getSearchTerm(source) {
    return getField(source, ['title', 'product_title', 'productTitle', 'name', 'handle', 'product_handle', 'productHandle']);
  }

  function compactUnique(values) {
    var seen = {};
    var results = [];

    values.forEach(function (value) {
      var normalized = String(value || '').trim();
      if (!normalized || seen[normalized]) return;
      seen[normalized] = true;
      results.push(normalized);
    });

    return results;
  }

  function normalizeFavoriteItem(item) {
    var product = item && item.product && typeof item.product === 'object' ? item.product : {};
    var source = Object.assign({}, item || {}, product);
    var productId = getFavoriteProductId(source, product);

    return {
      item: item,
      source: source,
      productId: productId,
      searchTerm: getSearchTerm(source)
    };
  }

  async function getShopifyProducts(productIds, searchTerms) {
    if (!productIds.length || !window.GroupHiitApi || typeof window.GroupHiitApi.getShopifyProducts !== 'function') {
      return {};
    }

    try {
      return await window.GroupHiitApi.getShopifyProducts(productIds, {
        searchTerms: searchTerms
      });
    } catch (error) {
      console.error('Unable to load Shopify products for favorites:', error);
      return {};
    }
  }

  function buildFavorite(favoriteItem, productsById) {
    var source = favoriteItem.source;
    var shopifyProduct = productsById[favoriteItem.productId] || {};
    var merged = Object.assign({}, source, shopifyProduct);
    var handle = getField(merged, ['handle', 'product_handle', 'productHandle']);
    var title = getField(merged, ['title', 'product_title', 'productTitle', 'name']) || 'Favorite product';

    return {
      id: favoriteItem.item && favoriteItem.item.id ? favoriteItem.item.id : favoriteItem.productId,
      productId: favoriteItem.productId,
      variantId: getField(source, ['variant_id', 'variantId']),
      title: title,
      handle: handle,
      image: getProductImage(merged),
      type: getField(merged, ['product_type', 'productType', 'type']),
      tags: getProductTags(merged),
      url: handle ? '/products/' + handle : ''
    };
  }

  function createCard(favorite, root) {
    var card = document.createElement('article');
    var imageMarkup = favorite.image
      ? `<img src="${escapeHtml(favorite.image)}" alt="${escapeHtml(favorite.title)}" loading="lazy">`
      : '<div class="favorites-card__image-placeholder" aria-hidden="true"></div>';
    var url = favorite.url || '#';

    card.className = 'favorites-card';
    card.innerHTML = `
      <a href="${escapeHtml(url)}" class="favorites-card__image-wrap">
        ${imageMarkup}
        <div class="play-overlay"><div class="play-icon"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></div></div>
      </a>
      <a href="${escapeHtml(url)}" class="favorites-card__title">${escapeHtml(favorite.title)}</a>
      <button class="favorites-card__remove">Remove</button>
    `;

    card.querySelector('.favorites-card__remove').addEventListener('click', async (e) => {
      const btn = e.target;
      btn.textContent = 'Removing...';
      btn.disabled = true;
      try {
        await window.GroupHiitApi.removeFavorite({ productId: favorite.productId, clerkUserId: window.Clerk?.user?.id });
        loadFavorites(root, window.Clerk?.user);
      } catch (err) {
        btn.textContent = 'Remove';
        btn.disabled = false;
      }
    });
    return card;
  }

  async function renderFavorites(root, payload) {
    const raw = getFavoritesArray(payload);
    const favoriteItems = raw.map(normalizeFavoriteItem).filter(function (favoriteItem) {
      return favoriteItem.productId;
    });
    const productIds = compactUnique(favoriteItems.map(function (favoriteItem) {
      return favoriteItem.productId;
    }));
    const searchTerms = compactUnique(favoriteItems.map(function (favoriteItem) {
      return favoriteItem.searchTerm;
    }));
    const productsById = await getShopifyProducts(productIds, searchTerms);
    const allFavs = favoriteItems.map(function (favoriteItem) {
      return buildFavorite(favoriteItem, productsById);
    });

    const buckets = { all: [], workouts: [], yoga: [], recovery: [], products: [] };
    
    allFavs.forEach(item => {
      const type = (item.type || '').trim();
      const isClass = (item.tags || []).some(t => t.toLowerCase() === 'class');
      buckets.all.push(item);
      
      if (!isClass) buckets.products.push(item);
      else if (type === 'Yoga') buckets.yoga.push(item);
      else if (['Mobility & Recovery', 'Shoulder Mobility', 'Warm-up', 'Cool Down'].includes(type)) buckets.recovery.push(item);
      else buckets.workouts.push(item);
    });

    Object.keys(buckets).forEach(key => {
      const count = buckets[key].length;
      const tab = root.querySelector(`[data-tab-target="${key}"]`);
      const grid = root.querySelector(`[data-${key}-grid]`);
      
      if (tab) {
        const label = tab.textContent.split(' (')[0];
        tab.textContent = `${label} (${count})`;
        tab.style.setProperty('display', (key === 'all' || count > 0) ? 'block' : 'none', 'important');
      }
      
      if (grid) {
        grid.innerHTML = '';
        grid.style.setProperty('display', 'grid', 'important');
        buckets[key].forEach(f => grid.appendChild(createCard(f, root)));
      }
    });

    if (!allFavs.length) {
      showStatus(root, 'empty', 'You do not have any favorites yet.');
    } else {
      hideStatus(root);
    }
  }

  async function loadFavorites(root, user) {
    if (!user) {
      // Uses your exact original login message format
      showStatus(root, 'logged-out', 'Please <button class="clerk-login-trigger" style="background:none;border:none;color:#00bcd4;text-decoration:underline;cursor:pointer;font:inherit;padding:0;">log in</button> to view your favorites.');
      return;
    }
    
    showStatus(root, 'loading', 'Loading your favorites...');
    
    try {
      const payload = await window.GroupHiitApi.getFavorites({ clerkUserId: user.id });
      console.log({payload})
      await renderFavorites(root, payload);
    } catch (error) {
      showStatus(root, 'error', 'We could not load your favorites. ' + error.message);
    }
  }

  function init() {
    const root = document.querySelector('[data-favorites-page]');
    if (!root) return;

    // Tab Switching Logic
    root.querySelectorAll('.gh-tab').forEach(btn => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('.gh-tab, .gh-tab-panel').forEach(el => el.classList.remove('active'));
        btn.classList.add('active');
        const panel = document.getElementById(btn.dataset.tabTarget);
        if(panel) panel.classList.add('active');
      });
    });

    // Listen for Clerk loading
    document.addEventListener('gh:accessResolved', () => loadFavorites(root, window.Clerk?.user));
    
    // Check Clerk on init
    if (window.Clerk?.user) {
        loadFavorites(root, window.Clerk.user);
    } else {
        // Respect your local storage fast sync key for logged out state
        if (localStorage.getItem('clerk_fast_sync') === 'logged_out') {
           loadFavorites(root, null);
        }
    }
  }
  
  init();
})();
